import React from "react";
import IPanel from "./interface";
import Container from "./styles";

const Panel: React.FC<IPanel> = ({styleInline, children}) => <Container styleInline={styleInline} >{children}</Container>;

export default Panel;
